module.exports = __webpack_public_path__ + "static/media/in.7fdfdb85.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/in.svg
// module id = 675
// module chunks = 0